import axios from "./axios";
import { ApiResponse } from "../types/express-data.type";
import {
  RouteSalesTargetCell,
  RouteSalesTargetMonth,
  RouteSalesTargetSaveResult,
} from "../types/route-sales-target.type";

const ROUTE_SALES_TARGETS_PATH = "/route-sales-targets";

/** A refused save is the server's Thai message in the toast. */
const WRITE_META = { suppressForbiddenRedirect: true };

/** S6: every route's days of `month`; no branch = every branch. */
export const getRouteSalesTargets = (month: string, branchCodes: string[]) => {
  const search = new URLSearchParams({ month });
  branchCodes.forEach((branchCode) => search.append("branch", branchCode));
  return axios.get<ApiResponse<RouteSalesTargetMonth>>(
    `${ROUTE_SALES_TARGETS_PATH}?${search.toString()}`,
  );
};

/** บันทึก — past days come back in `skipped`, not as an error. */
export const saveRouteSalesTargets = (targets: RouteSalesTargetCell[]) =>
  axios.put<ApiResponse<RouteSalesTargetSaveResult>>(
    ROUTE_SALES_TARGETS_PATH,
    { targets },
    { meta: WRITE_META },
  );
